// ./components/DownloadButton/index.jsx
import { motion } from 'framer-motion';
import { FaDownload } from 'react-icons/fa';
import { ImSpinner8 } from 'react-icons/im';
import './style.scss';

const DownloadButton = ({ onClick, disabled, filename, isHovering }) => {
  return (
    <motion.div
      className={`download-block ${disabled ? 'disabled' : ''}`}
      whileHover={disabled ? {} : 'hover'}
      initial="initial"
      animate={isHovering ? 'hover' : 'initial'}
    >
      <motion.div
        className="code-block"
        variants={{
          hover: {
            borderColor: 'rgba(76, 175, 80, 0.5)',
            transition: { duration: 0.3 },
          },
        }}
      >
        <motion.button
          className="download-button"
          onClick={onClick}
          disabled={disabled}
          whileTap={disabled ? {} : { scale: 0.95 }}
          title={filename}
        >
          <motion.div
            variants={{
              initial: { rotate: 0 },
              hover: {
                rotate: 360,
                transition: {
                  duration: 0.6,
                  ease: 'easeInOut',
                },
              },
            }}
          >
            {disabled ? (
              <ImSpinner8 size={16} className="spinning" />
            ) : (
              <FaDownload size={16} />
            )}
          </motion.div>
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default DownloadButton;
